import { z } from "zod";
import { PatientGetDetailResponse as ZPatientDetail } from "../lib/api/generated-zod/endpoints/patient/patient.zod";

export type PatientDetailParsed = z.infer<typeof ZPatientDetail>;

function getPatientDetailPayload(resp: unknown): unknown | null {
  if (!resp || typeof resp !== "object" || !("status" in (resp as any))) {
    return null;
  }
  const response = resp as { status?: number; data?: unknown };
  if (response.status !== 200) {
    return null;
  }
  return response.data;
}

export function parsePatientDetailOk(
  resp: unknown,
): PatientDetailParsed | null {
  const data = getPatientDetailPayload(resp);
  if (data === null) {
    return null;
  }

  const parsed = ZPatientDetail.safeParse(data);
  return parsed.success && parsed.data !== undefined ? parsed.data : null;
}
